import React, { useRef, useEffect, useCallback, Fragment } from 'react'
import { connect } from 'react-redux';
import { getObjectName } from '../../common/utils';


const Socket = ( { children, loggedIn, logout, sid, storeSocket, insertContact, modifyContact, removeContact, insertEvent, modifyEvent, removeEvent, insertFile, modifyFile, removeFile, insertGameplan, modifyGameplan, removeGameplan, insertGift, modifyGift, removeGift, insertLeadOpp, modifyLeadOpp, removeLeadOpp, insertList, modifyList, removeList, insertLoan, modifyLoan, removeLoan, insertNote, modifyNote, removeNote, insertReview, modifyReview, removeReview, insertTask, modifyTask, removeTask, insertComm, modifyComm, removeComm, loadComms, insertMessage, modifyMessage, removeMessage, insertRefOut, modifyRefOut, removeRefOut, insertOffer, modifyOffer, removeOffer, insertPlaybook, modifyPlaybook, removePlaybook, insertTemplate, modifyTemplate, removeTemplate } ) => {
    const socket = useRef( null );
    const sessionTimer = useRef( null );

    const onOpen = useCallback( () => {
        console.log( 'Socket open' );
        const msg = { action: 'subscribe', data: { sid: sid, channel: 'cdc' } };
        console.log( 'Sending: ' + JSON.stringify( msg ) );
        socket.current.send( JSON.stringify( msg ) );
    }, [ sid ] );

    const onMsg = useCallback( ( e ) => {
        const msg = JSON.parse( e.data );

        console.log( 'Socket Msg: ', msg );
        switch ( getObjectName( msg.oid ) ) {
            case 'contact':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertContact( { cid: msg.oid, cdc: msg.cdc } );
                        break;

                    case 'modify':
                        modifyContact( { cid: msg.oid, cdc: msg.cdc } );
                        break;

                    case 'remove':
                        removeContact( { cid: msg.oid } );
                        break;

                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'event':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertEvent( { eid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'modify':
                        modifyEvent( { eid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'remove':
                        removeEvent( { eid: msg.oid } );
                        break;
    
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'file':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertFile( { fid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'modify':
                        modifyFile( { fid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'remove':
                        removeFile( { fid: msg.oid } );
                        break;
    
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'gameplan':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertGameplan( { gpid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'modify':
                        modifyGameplan( { gpid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'remove':
                        removeGameplan( { gpid: msg.oid } );
                        break;
    
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'gift':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertGift( { gid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'modify':
                        modifyGift( { gid: msg.oid, cdc: msg.cdc } );
                        break;
    
                    case 'remove':
                        removeGift( { gid: msg.oid } );
                        break;
    
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;
            
            case 'leadopp':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertLeadOpp( { loid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'modify':
                        modifyLeadOpp( { loid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'remove':
                        removeLeadOpp( { loid: msg.oid } );
                        break;
        
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'list':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertList( { gid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'modify':
                        modifyList( { gid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'remove':
                        removeList( { gid: msg.oid } );
                        break;
        
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'loan':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertLoan( { lid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'modify':
                        modifyLoan( { lid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'remove':
                        removeLoan( { lid: msg.oid } );
                        break;
        
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'note':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertNote( { nid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'modify':
                        modifyNote( { nid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'remove':
                        removeNote( { nid: msg.oid } );
                        break;
        
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'offer':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertOffer( { oid: msg.oid, cdc: msg.cdc } );
                        break;
            
                    case 'modify':
                        modifyOffer( { oid: msg.oid, cdc: msg.cdc } );
                        break;
            
                    case 'remove':
                        removeOffer( { oid: msg.oid } );
                        break;
            
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'playbook':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertPlaybook( { oid: msg.oid, cdc: msg.cdc } );
                        break;
                
                    case 'modify':
                        modifyPlaybook( { oid: msg.oid, cdc: msg.cdc } );
                        break;
                
                    case 'remove':
                        removePlaybook( { oid: msg.oid } );
                        break;
                
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;
        
            case 'referredout':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertRefOut( { roid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'modify':
                        modifyRefOut( { roid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'remove':
                        removeRefOut( { roid: msg.oid } );
                        break;
        
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'review':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertReview( { rid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'modify':
                        modifyReview( { rid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'remove':
                        removeReview( { rid: msg.oid } );
                        break;
        
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'task':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertTask( { tid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'modify':
                        modifyTask( { tid: msg.oid, cdc: msg.cdc } );
                        break;
        
                    case 'remove':
                        removeTask( { tid: msg.oid } );
                        break;
        
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'template':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertTemplate( { tid: msg.oid, cdc: msg.cdc } );
                        break;
            
                    case 'modify':
                        modifyTemplate( { tid: msg.oid, cdc: msg.cdc } );
                        break;
            
                    case 'remove':
                        removeTemplate( { tid: msg.oid } );
                        break;
            
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'comm':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertComm( { cid: msg.oid, cdc: msg.cdc } );
                        break;
            
                    case 'modify':
                        modifyComm( { cid: msg.oid, cdc: msg.cdc } );
                        break;
            
                    case 'remove':
                        removeComm( { cid: msg.oid } );
                        break;
            
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;

            case 'message':
                switch ( msg.cdcAction ) {
                    case 'insert':
                        insertMessage( { mid: msg.oid, cdc: msg.cdc } );
                        break;
                
                    case 'modify':
                        modifyMessage( { mid: msg.oid, cdc: msg.cdc } );
                        break;
            
                    case 'remove':
                        removeMessage( { mid: msg.oid } );
                        break;
                
                    default:
                        console.log( 'Unknown cdcAction: ', msg );
                }
                break;
    
            default:
                console.log( 'Unknown cdc obj: ', msg );
        }
    }, [ insertContact, modifyContact, removeContact, insertEvent, modifyEvent, removeEvent, insertGameplan, modifyGameplan, removeGameplan, insertGift, modifyGift, removeGift, insertLeadOpp, modifyLeadOpp, removeLeadOpp, insertList, modifyList, removeList, insertLoan, modifyLoan, removeLoan, insertNote, modifyNote, removeNote, insertReview, modifyReview, removeReview, insertTask, modifyTask, removeTask, insertComm, modifyComm, removeComm, insertMessage, modifyMessage, removeMessage, insertRefOut, modifyRefOut, removeRefOut, insertOffer, modifyOffer, removeOffer, insertFile, modifyFile, removeFile, insertPlaybook, modifyPlaybook, removePlaybook, insertTemplate, modifyTemplate, removeTemplate ] );

    const onClose = useCallback( ( e ) => {
        console.log( 'Close socket: ', e );
        if ( !e.wasClean ) {
            console.log( 'dirty close!!' );
        }
    }, [ ] );

    const onError = useCallback( ( e ) => {
        console.log( 'Socket error: ', e );
    }, [] );

    const openSocket = useCallback( () => {
        socket.current = new WebSocket( 'wss://f4q7uulv08.execute-api.us-east-1.amazonaws.com/dev' );
        storeSocket( socket );
        socket.current.onopen = onOpen;
        socket.current.onmessage = onMsg;
        socket.current.onclose = onClose;
        socket.current.onerror = onError;
    }, [ onOpen, onMsg, onClose, onError, storeSocket ] );

    const reconnectSocket = useCallback( () => {
        if ( socket.current ) {
            socket.current.close();
        }
        if ( loggedIn ) {
            openSocket();
        }
    }, [ openSocket, loggedIn ] );

    const startTimer = useCallback( () => {
        sessionTimer.current = setTimeout( () => {
            console.log( 'Session timeout - need to log back in' );
            logout();
        }, 1000 * 60 * 120 );
    }, [ logout ] );

    const extendSession = useCallback( () => {
        const msg = { action: 'session', data: { sid: sid } };
        if ( socket.current && socket.current.readyState === 1 ) {
            console.log( 'Extending session: ' + JSON.stringify( msg ) );
            socket.current.send( JSON.stringify( msg ) );
        } else {
            console.log( 'reconnecting to extend session' );
            reconnectSocket();
        }
    }, [ sid, reconnectSocket ] );

    const resetTimer = useCallback( ( e ) => {
        if ( e.target.tagName === 'A' ) {
            clearTimeout( sessionTimer.current );

            if ( loggedIn ) {
                console.log( 'timer reset!' );
                extendSession();
                startTimer();
            }
        }
    }, [ loggedIn, extendSession, startTimer ] );

    useEffect( () => {
        if ( loggedIn ) {
            openSocket();
        }

        return () => {
            console.log( 'Closing socket' );
            if ( socket.current ) {
                socket.current.close();
            }
            console.log( 'Stopping timer' );
            clearTimeout( sessionTimer.current );
        }
    }, [ loggedIn, openSocket ] );

    useEffect( () => {
        window.addEventListener( 'click', resetTimer );
        console.log( 'Starting session timer for 1st time' );
        startTimer();
    }, [ resetTimer, startTimer ] );

    // Keep socket alive w/ heartbeat and hourly reconnect
    useEffect( () => {
        const msg = { action: 'ping', data: { sid: sid } };

        const heartbeat = setInterval( () => {
            if ( loggedIn ) {
                if ( socket.current && socket.current.readyState === 1 ) {
                    console.log( 'thump thump: ' + JSON.stringify( msg ) );
                    socket.current.send( JSON.stringify( msg ) );
                } else {
                    console.log( 'reconnecting to extend session' );
                    reconnectSocket();
                }
            }
        }, 1000 * 30 );

        const reboot = setInterval( () => {
            console.log( 'Reconnecting after an hour...' );
            if ( loggedIn ) {
                reconnectSocket();
            }
        }, 1000 * 60 * 60 );

        return () => {
            clearInterval( heartbeat );
            clearInterval( reboot );
        }
    }, [ sid, loggedIn, reconnectSocket ] );

    return (
        <Fragment>
            { children }
        </Fragment>
    )
}

const mapProps = ( state ) =>( {
    loggedIn: state.user.password,
    sid: state.user.sid,
} );

const mapDispatch = ( dispatch ) => ( {
    storeSocket: dispatch.user.storeSocket,
    logout: dispatch.user.logout,

    insertContact: dispatch.contacts.insert,
    modifyContact: dispatch.contacts.modify,
    removeContact: dispatch.contacts.remove,

    insertEvent: dispatch.events.insert,
    modifyEvent: dispatch.events.modify,
    removeEvent: dispatch.events.remove,

    insertFile: dispatch.files.insert,
    modifyFile: dispatch.files.modify,
    removeFile: dispatch.files.remove,

    insertGameplan: dispatch.gameplan.insert,
    modifyGameplan: dispatch.gameplan.modify,
    removeGameplan: dispatch.gameplan.remove,

    insertGift: dispatch.gifts.insert,
    modifyGift: dispatch.gifts.modify,
    removeGift: dispatch.gifts.remove,

    insertLeadOpp: dispatch.leadopps.insert,
    modifyLeadOpp: dispatch.leadopps.modify,
    removeLeadOpp: dispatch.leadopps.remove,

    insertList: dispatch.lists.insert,
    modifyList: dispatch.lists.modify,
    removeList: dispatch.lists.remove,

    insertLoan: dispatch.loans.insert,
    modifyLoan: dispatch.loans.modify,
    removeLoan: dispatch.loans.remove,

    insertNote: dispatch.notes.insert,
    modifyNote: dispatch.notes.modify,
    removeNote: dispatch.notes.remove,

    insertOffer: dispatch.offers.insert,
    modifyOffer: dispatch.offers.modify,
    removeOffer: dispatch.offers.remove,

    insertReview: dispatch.reviews.insert,
    modifyReview: dispatch.reviews.modify,
    removeReview: dispatch.reviews.remove,

    insertTask: dispatch.tasks.insert,
    modifyTask: dispatch.tasks.modify,
    removeTask: dispatch.tasks.remove,

    insertComm: dispatch.comms.insert,
    modifyComm: dispatch.comms.modify,
    removeComm: dispatch.comms.remove,
    loadComms: dispatch.comms.loadComms,

    insertMessage: dispatch.messages.insert,
    modifyMessage: dispatch.messages.modify,
    removeMessage: dispatch.messages.remove,
    
    insertRefOut: dispatch.referredout.insert,
    modifyRefOut: dispatch.referredout.modify,
    removeRefOut: dispatch.referredout.remove,

    insertPlaybook: dispatch.playbooks.insert,
    modifyPlaybook: dispatch.playbooks.modify,
    removePlaybook: dispatch.playbooks.remove,

    insertTemplate: dispatch.templates.insert,
    modifyTemplate: dispatch.templates.modify,
    removeTemplate: dispatch.templates.remove,
} );

export default connect( mapProps, mapDispatch )( Socket );